import { useSyncExternalStore } from 'react';
import { createRequiredContext } from '../../shared/create-required-context';
import type { AuthUser, Authenticator } from './authenticator';

export const [AuthenticatorContext, useAuthenticator] =
  createRequiredContext<Authenticator>('AuthenticatorContext');

/** The signed-in user, re-rendering when they sign in or out; null when nobody is. */
export function useCurrentUser(): AuthUser | null {
  const authenticator = useAuthenticator();
  return useSyncExternalStore(authenticator.subscribe, authenticator.currentUser);
}
